const THROTTLE_LIMIT = 250;

class ImageSizes {
  /**
   * @param {HTMLImageElement} image
   */
  constructor(image) {
    this.image = image;
    this.connect();
  }

  connect = () => {
    this.setSizes();

    this.image.addEventListener("load", this.setSizes, { once: true });

    this.throttledSetSizes = throttle(this.setSizes, THROTTLE_LIMIT);
    window.addEventListener("resize", this.throttledSetSizes);
  };

  setSizes = () => {
    this.image.setAttribute("sizes", `${this.image.width}px`);
  };

  disconnect = () => {
    this.image.removeEventListener("load", this.setSizes);
    window.removeEventListener("resize", this.throttledSetSizes);
  };
}

/**
 * Throttle a function to limit its execution rate.
 *
 * @param {Function} callback - The function to throttle.
 * @param {number} limit - The time limit in milliseconds.
 */
function throttle(callback, limit) {
  let lastCallback;
  let lastRan;

  return (...args) => {
    if (!lastRan) {
      callback(args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastCallback);
      const elapsed = Date.now() - lastRan;

      lastCallback = setTimeout(() => {
        if (elapsed >= limit) {
          callback(args);
          lastRan = Date.now();
        }
      }, limit - elapsed);
    }
  };
}

export default ImageSizes;
